var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { position, space, fontSize, display, flexDirection, justifyContent, alignItems, width, maxWidth, height, backgroundSize, backgroundPosition, backgroundRepeat, boxShadow, order, themeGet, } from 'styled-system';
import { breakpoint } from '../../common/theme/helper';
import { Grid } from '../../common/components/Grid';
import { ResponsiveLazyImage, ResponsiveLazyImagePropsShape, } from '../../common/components/LazyImage';
import { CenterRightControls, CenterLeftControls, } from '../../common/components/LazyCarouselControls';
import LazyCarousel from '../../common/components/LazyCarousel';
import { LinkButton } from '../../common/components/Link';
import { Text } from '../../common/components/Text';
import { Stoerer } from '../../common/components/Stoerer';
import CountDown from './CountDown';
import { DisclaimerSubscription } from '../../common/event-bus/EventSubscription';
import LegalNotesLink from './LegalNotesLink';
import { getPageAppTrackerProps, } from '../../common/tracking/getTrackerProps';
import dispatchTrackingEvent from '../../common/tracking/dispatchTrackingEvent';
import { ThemedMedia } from '../../common/components/Media';
export var ButtonType;
(function (ButtonType) {
    ButtonType["Primary"] = "Primary";
    ButtonType["Secondary"] = "Secondary";
})(ButtonType || (ButtonType = {}));
var HomepageTopTeaserGrid = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
HomepageTopTeaserGrid.defaultProps = {
    px: 0,
    pb: ['40px', 6, null, '56px'],
};
var SlideContainer = styled.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  background-color: ", ";\n  text-decoration: none;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  background-color: ", ";\n  text-decoration: none;\n"])), display, flexDirection, height, boxShadow, width, function (_a) {
    var bg = _a.bg;
    return (bg ? bg : themeGet('colors.gray.12'));
});
SlideContainer.defaultProps = {
    display: 'flex',
    flexDirection: ['column', 'row'],
    height: [368, 220, 304, 394],
    width: 1,
};
var InformationBox = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  color: ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  color: ",
    ";\n"])), display, flexDirection, justifyContent, alignItems, order, width, height, space, function (props) {
    return props.informationBoxColor
        ? props.informationBoxColor
        : themeGet('colors.gray.10');
});
InformationBox.defaultProps = {
    width: [1, '70%', null, '80%'],
    height: ['200px', 'auto'],
    pl: [0, '40px', 6, 7],
    py: [3, null, '28px', '66px'],
    display: 'flex',
    flexDirection: 'column',
    justifyContent: ['flex-start', 'space-between'],
    alignItems: ['center', 'normal'],
    order: [2, 1],
};
var EllipsisParagraph = styled(Text)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])), space, maxWidth, order);
EllipsisParagraph.defaultProps = {
    mt: 0,
    maxWidth: ['285px', null, '396px', '520px'],
};
var Title = styled(EllipsisParagraph)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-bottom: ", "px;\n\n  ", " {\n    margin-bottom: 0;\n  }\n"], ["\n  margin-bottom: ", "px;\n\n  ", " {\n    margin-bottom: 0;\n  }\n"])), function (props) { return (props.withSubtitle ? 0 : 32); }, breakpoint(0));
Title.defaultProps = __assign({}, EllipsisParagraph.defaultProps, { as: 'h2', mx: 0, fontSize: ['22px', null, '30px', 8], lineHeight: [4, null, 5, 6], order: [1, 2] });
var Subtitle = styled(EllipsisParagraph)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), fontSize, space);
Subtitle.defaultProps = __assign({}, EllipsisParagraph.defaultProps, { as: 'p', fontSize: [4, null, 5, '22px'], mt: [1, null, 2, 3], order: [2, 3] });
var CampaignDuration = styled(EllipsisParagraph)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), fontSize, space);
CampaignDuration.defaultProps = __assign({}, EllipsisParagraph.defaultProps, { as: 'p', fontSize: [4, null, null, 5], mb: [null, '28px', '66px', '72px'], order: [3, 1] });
var Button = styled(LinkButton)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  /* The !important is because of Shop-Reboot :'( */\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  /* The !important is because of Shop-Reboot :'( */\n  ",
    ";\n"])), order, space, width, fontSize, boxShadow, themeGet('colors.button.hover'), function (props) {
    return props.type === ButtonType.Secondary && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      color: ", " !important;\n      background-color: ", ";\n      border: 1px solid ", ";\n\n      &:hover {\n        color: ", " !important;\n        background-color: ", ";\n        border: 1px solid ", ";\n      }\n    "], ["\n      color: ", " !important;\n      background-color: ", ";\n      border: 1px solid ", ";\n\n      &:hover {\n        color: ", " !important;\n        background-color: ", ";\n        border: 1px solid ", ";\n      }\n    "])), themeGet('colors.gray.10')(props), themeGet('colors.white')(props), themeGet('colors.gray.9')(props), themeGet('colors.button.hover')(props), themeGet('colors.white')(props), themeGet('colors.button.hover')(props));
});
Button.defaultProps = __assign({}, LinkButton.defaultProps, { as: 'button', width: '160px', px: 0, py: 2, mt: [1, null, '10px', '18px'], fontSize: 4, boxShadow: 'none', order: 4 });
var RightSideWrapper = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), position, width, height, order);
RightSideWrapper.defaultProps = {
    position: 'relative',
    width: 1,
    order: [1, 2],
};
var ImageContainer = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), display, height);
ImageContainer.defaultProps = {
    height: [168, 220, 304, 394],
};
var Image = styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  background-image: ", ";\n  opacity: ", ";\n  transition: opacity 0.3s ease-in-out;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  background-image: ", ";\n  opacity: ", ";\n  transition: opacity 0.3s ease-in-out;\n"])), width, height, backgroundRepeat, backgroundPosition, backgroundSize, function (_a) {
    var image = _a.image;
    return "url(" + image + ")";
}, function (_a) {
    var show = _a.show;
    return "" + Number(show);
});
Image.defaultProps = {
    width: 1,
    height: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
};
var CarouselContainer = styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  width: inherit;\n  ", ";\n"], ["\n  width: inherit;\n  ", ";\n"])), boxShadow);
CarouselContainer.defaultProps = {
    boxShadow: ['0 2px 6px 0 #c0c0c0', 'none'],
};
var useLockWindowScrolling = function () {
    var _a = __read(useState(false), 2), lockScroll = _a[0], setLockScroll = _a[1];
    useEffect(function () {
        document.body.style.overflow = lockScroll ? 'hidden' : 'visible';
        // hooray for ie 11, not supporting Event constructor
        var event;
        if (typeof UIEvent === 'function') {
            event = new UIEvent('resize');
        }
        else {
            event = document.createEvent('UIEvent');
            event.initEvent('resize', true, true);
        }
        window.dispatchEvent(event);
    }, [lockScroll]);
    return [lockScroll, setLockScroll];
};
var HomepageTopTeaser = function (_a) {
    var items = _a.items;
    var _b = __read(useLockWindowScrolling(), 2), lockScroll = _b[0], setLockScroll = _b[1];
    var _c = __read(useState(0), 2), activeSlide = _c[0], setActiveSlide = _c[1];
    useEffect(function () {
        var activeTopTeaserPromotion = {
            name: items[activeSlide].tracking.name,
            placement: items[activeSlide].tracking.placement,
            position: activeSlide,
        };
        dispatchTrackingEvent({
            event: 'promoView',
            eventAction: 'view',
            eventCategory: 'promotion',
            eventData: {
                promotions: [activeTopTeaserPromotion],
            },
        });
    }, [activeSlide, items]);
    var onClickLegalNotes = function (_a) {
        var emit = _a.emit, html = _a.html;
        return function (event) {
            event.preventDefault();
            emit({ html: html, open: true, lockScroll: true, shouldAutoplay: false });
        };
    };
    var handleAfterSlide = useCallback(function (currentSlide) {
        setActiveSlide(currentSlide);
    }, [activeSlide]);
    var hasMultipleSlides = items.length > 1;
    var shouldAutoplay = hasMultipleSlides && !lockScroll;
    var arrowProps = {
        display: 'block',
        arrowSize: '14px',
        controlShadow: 'none',
        size: '28px',
        mx: 2,
    };
    return (React.createElement(ThemedMedia, null, function (_a) {
        var tablet = _a.tablet, desktop = _a.desktop;
        return (React.createElement(HomepageTopTeaserGrid, null,
            React.createElement(CarouselContainer, null,
                React.createElement(LazyCarousel, { showControlsOnHover: desktop, renderCenterLeftControls: function (props) { return (React.createElement(CenterLeftControls, __assign({}, arrowProps, props))); }, renderCenterRightControls: function (props) { return (React.createElement(CenterRightControls, __assign({}, arrowProps, props))); }, wrapAround: hasMultipleSlides, autoplay: shouldAutoplay, autoplayInterval: 5000, pauseOnHover: true, afterSlide: handleAfterSlide }, items.map(function (_a, index) {
                    var stoerer = _a.stoerer, imageProps = _a.image, campaignDuration = _a.campaignDuration, countDown = _a.countDown, title = _a.title, subtitle = _a.subtitle, cta = _a.cta, informationBoxBg = _a.informationBoxBg, informationBoxColor = _a.informationBoxColor, legalDisclaimer = _a.legalDisclaimer, _b = _a.tracking, _c = _b === void 0 ? {} : _b, name = _c.name, placement = _c.placement;
                    return (React.createElement(SlideContainer, __assign({ key: "slide-" + index, bg: informationBoxBg }, getPageAppTrackerProps(__assign({}, (index === 0 && {
                        'data-prefetch': true,
                    }), { 'data-testid': "homepage-top-teaser-slide-" + index, type: cta.type, href: cta.href }), {
                        event: 'promoClick',
                        eventData: {
                            promotions: [
                                {
                                    name: name,
                                    placement: placement,
                                    position: index,
                                },
                            ],
                        },
                    })),
                        React.createElement(InformationBox, { informationBoxColor: informationBoxColor, "data-testid": "information-box-slide" },
                            campaignDuration ? (React.createElement(CampaignDuration, { "data-testid": "campaign-duration" }, campaignDuration)) : (React.createElement(CountDown, { label: countDown.label, endDate: countDown.endDate })),
                            title && (React.createElement(Title, { withSubtitle: Boolean(subtitle), "data-testid": "title" }, title)),
                            subtitle && (React.createElement(Subtitle, { "data-testid": "subtitle" }, subtitle)),
                            React.createElement(Button, { "data-testid": "button", type: cta.type }, cta.label)),
                        React.createElement(RightSideWrapper, { "data-testid": "right-side-slide" },
                            React.createElement(ImageContainer, { "data-testid": "image-container-slide" },
                                stoerer && (React.createElement(Stoerer, { label: stoerer.label, borderColor: stoerer.borderColor, themeTop: [0, 3, '28px', '66px'] })),
                                React.createElement(ResponsiveLazyImage, __assign({}, imageProps), function (_a) {
                                    var thumbnail = _a.thumbnail, image = _a.image, loaded = _a.loaded;
                                    return (React.createElement(Image, { "data-testid": "image", show: loaded, image: loaded ? image : thumbnail }));
                                })),
                            legalDisclaimer && (React.createElement(DisclaimerSubscription, null, function (_a) {
                                var value = _a.value, emit = _a.emit;
                                var linkLabel = legalDisclaimer.linkLabel, linkLabelColor = legalDisclaimer.linkLabelColor, contentHtml = legalDisclaimer.contentHtml;
                                if (value.lockScroll !== lockScroll) {
                                    setLockScroll(value.lockScroll);
                                }
                                return (React.createElement(LegalNotesLink, { alignBottom: tablet, linkLabel: linkLabel, linkLabelColor: linkLabelColor, onClick: onClickLegalNotes({
                                        emit: emit,
                                        html: contentHtml,
                                    }) }));
                            })))));
                })))));
    }));
};
HomepageTopTeaser.propTypes = {
    /** Array of items */
    items: PropTypes.arrayOf(PropTypes.shape({
        /** Item's störer */
        stoerer: PropTypes.shape({
            /** Störer label */
            label: PropTypes.string,
            /** Störer border color */
            borderColor: PropTypes.string,
        }),
        /** Item's image */
        image: PropTypes.shape(__assign({ 
            /** Alternative image text. */
            alt: PropTypes.string }, ResponsiveLazyImagePropsShape)),
        /** Item's title */
        title: PropTypes.string,
        /** Item's subtitle */
        subtitle: PropTypes.string,
        /** Text to show the campaign duration */
        campaignDuration: PropTypes.string,
        /** Countdown */
        countDown: PropTypes.shape({
            /** Countdown text */
            label: PropTypes.string,
            /** Countdown end date */
            endDate: PropTypes.string,
        }),
        /** Item's CTA */
        cta: PropTypes.shape({
            /** Item's cta type */
            type: PropTypes.oneOf([ButtonType.Primary, ButtonType.Secondary]),
            /** Item's cta label */
            label: PropTypes.string,
            /** Item's cta href */
            href: PropTypes.string,
        }).isRequired,
        /** Item's information box background */
        informationBoxBg: PropTypes.string,
        /** Item's information box text color */
        informationBoxColor: PropTypes.string,
        /** Teaser legal disclaimer */
        legalDisclaimer: PropTypes.object,
        /** Tracking props */
        tracking: PropTypes.shape({
            /** Tracking item name */
            name: PropTypes.string,
            /** Tracking item placement */
            placement: PropTypes.string,
        }),
    }).isRequired),
};
export default HomepageTopTeaser;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;
